import { CommonModule } from "@angular/common";
import { NgModule, Type } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LanguageSelectorComponent } from "./languageSelector/languageSelector.component";
import { TranslateDirective } from "./translate/translate.directive";

const privateComponents: Type<any>[] = [

];

const publicComponents: Type<any>[] = [
    LanguageSelectorComponent
];

const publicDirectives: Type<any>[] = [
    TranslateDirective
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...publicDirectives],
    exports: [...publicComponents, ...publicDirectives]
})
export class TranslationDirectivesModule {
    constructor() {
    }
}
